/* eslint-disable prettier/prettier */
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import ReactDataTable from '../../../ReactDataTable/ReactDataTable';

const ProductModelForm = ({ remove, add }) => {
    const { values } = useFormikContext();
    const column = [
        {
            name: 'Model Name',
            cell: (_, i) => <ReactInput name={`product_model[${i}].model_name`} />,
        },
        {
            name: 'Feeds Per Inch',
            cell: (_, i) => <ReactInput name={`product_model[${i}].feeds_per_inch`} />,
        },
        {
            name: 'Sinker Top',
            cell: (_, i) => <ReactInput name={`product_model[${i}].sinker_top`} />,
        },
        {
            name: 'Gauge',
            cell: (_, i) => <ReactInput name={`product_model[${i}].gauge`} />,
        },
        {
            name: 'Diameter Range',
            cell: (_, i) => <ReactInput name={`product_model[${i}].diameter_range`} />,
        },
        {
            name: 'Speed Factor',
            cell: (_, i) => <ReactInput name={`product_model[${i}].speed_factor`} />,
        },
        {
            name: <Button onClick={() => add({})}>
                <span style={{
                    fontSize: '14px'
                }}>
                    Add <FaPlus />
                </span>
            </Button>,
            width: '120px',
            cell: (_, i) => (
                <div>
                    {i === 0 ? (
                        <>
                            <Button onClick={() => add({})}>
                                <FaPlus />
                            </Button>
                            <span> </span>
                            <Button onClick={() => remove(i)}>
                                <FaMinus />
                            </Button>
                        </>
                    ) : (
                        <Button onClick={() => remove(i)}>
                            <FaMinus />
                        </Button>
                    )}
                </div>
            ),
        },
        // {
        //     name: <Button onClick={() => add({})}>
        //         <span style={{
        //             fontSize: '14px'
        //         }}>
        //             Action <FaPlus />
        //         </span>
        //     </Button>,
        //     width: '120px',
        //     cell: (_, i) => (
        //         <div>
        //             {i === 0 ? (
        //                 <Button onClick={() => add({})}>
        //                     <FaPlus />
        //                 </Button>
        //             ) : (
        //                 <Button onClick={() => remove()}>
        //                     <FaMinus />
        //                 </Button>
        //             )}
        //         </div>
        //     ),
        // },
    ];
    // Log
    console.log('values model =>', values.product_model);
    return (
        <div>
            <ReactDataTable columns={column} data={values.product_model} pagination={false} />
        </div>
    );
};
export default ProductModelForm;
